import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import login from "./loginReducer";
import data from "./dataReducer";
import user from "./userReducer"; 
import upload from "./uploadReducer"; 
import updateuserstoactive from "./updateUsersToActiveReducer";
import updateuserstoinactive from "./updateUsersToInactiveReducer";
import countuser from "./countUserReducer";
import countplainuser from "./countPlainUserReducer";
import userRoles from "./checkUserReducer";
import file from "./filesManageReducer"; 
import countfile from "./countFileReducer";
import mainuser from "./mainUserReducer";
import updatepassword from "./updatePasswordReducer"; 
import checkhotspot from "./checkFileStatusReducer"; 
import downloadHotspot from "./downloadHotspotReducer";
import retrieveComp from './getAllCompanyReducer';
import concessionFormReturn from '././ConcessionFormReducer';
import concessionUserReturn from '././concessionUserReducer';
import modis from './hotspotRawMODISReducer';
import viirs from './hotspotRawVIIRSreducer';
import noaa from './hotspotRawNOAAreducer';
import filteredHotspot from '././filteredHotspotReducer';
import editCompany from '././editCompanyReducer';
import editUser from '././editUserReducer';
import reportList from '././reportListReducer';
import submitFormRes from '././submitConcessionFormReducer';

import emailViewEdit from '././emailReducer';
import plantationViewEdit from '././plantationReducer';
import getCountry from '././countryReducer';
export default combineReducers({
    form: reduxForm,
   // sign,
    data,
    user,
    signIn: login, 
    upload, 
    updateuserstoactive,
    updateuserstoinactive,
    countuser,
    countplainuser,
    userRoles,
    file, 
    countfile, 
    mainuser,
    updatepassword, 
    checkhotspot,
    downloadHotspot,
    retrieveComp,
    concessionFormReturn,
    concessionUserReturn,
    modis,
    viirs,
    noaa,
    filteredHotspot,
    editCompany,
    editUser,
    reportList,
    submitFormRes,
    emailViewEdit,
    plantationViewEdit,
    getCountry
});



// WEBPACK FOOTER //
// ./src/reducers/index.js